module.exports = __webpack_public_path__ + "static/media/AI_1.5979ad04.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_1.png
// module id = 116
// module chunks = 0